// extracted by mini-css-extract-plugin
export default {"buttons":"buttons__zdxh0","deleteAllStudents":"deleteAllStudents__XZyn6"};